import moment from 'moment';
import React from 'react';
import { completeCarePlanActivity } from '../../../apis/carePlan';
import { updateConditionsByPatientId } from '../../../apis/conditions';
import { useCarePlan } from '../../../contexts/carePlan';
import { useCristal } from '../../../contexts/cristal';
import { usePatient } from '../../../contexts/patient';
import { usePractitioner } from '../../../contexts/practitioner';
import { processCristal } from '../../../layouts/Questionnaire/New';
import { calculateCriSTALScore } from '../../../modules/unsw-cristal';
import { CristalConditionsGenerator } from '../../../modules/unsw-fhir-conditions';
import QuestionnaireMutator from '../../../modules/unsw-fhir-questionnaire/Utilities/QuestionnaireMutator';
import { IQuestionnaire } from '../../../modules/unsw-fhir/Questionnaire';
import { IQuestionnaireResponse } from '../../../modules/unsw-fhir/QuestionnaireResponse';
import CristalProvider from '../../Providers/Cristal';
import WizardQuestionnaire from '../Wizard';

interface CristalQuestionnaireProps {
  pageId: string;
  disabled?: boolean;
  practitionerId: string;
  onComplete?: (
    questionnaire: IQuestionnaire,
    questionnaireResponse?: IQuestionnaireResponse,
  ) => void | Promise<void>;
}

const CristalQuestionnaire = (props: CristalQuestionnaireProps) => {
  const { patient } = usePatient();
  const { practitioner } = usePractitioner();
  const { carePlan, setCarePlan } = useCarePlan();
  const { setScore } = useCristal();
  return (
    <WizardQuestionnaire
      {...props}
      name="cristal"
      beforeSave={async (response, qtniare) => {
        if (qtniare.name === 'cristal' && response) {
          let lResponse: IQuestionnaireResponse | undefined = response;
          const mutator = new QuestionnaireMutator(qtniare, response);
          if (patient && patient.birthDate) {
            const age = moment().diff(patient.birthDate, 'years', false);
            if (age >= 65) {
              lResponse = mutator.addResponse({ '8-1': 'true' });
              mutator.updateResponse(lResponse);
            }
          }

          if (!lResponse) return lResponse;
          const score = calculateCriSTALScore(lResponse);
          setScore(score);
          return mutator.addResponse({ '8-0': score.toString() }) || undefined;
        }
        return response;
      }}
      onComplete={async (questionnaire, response) => {
        if (carePlan && response && patient && practitioner) {
          const conditions = new CristalConditionsGenerator(
            questionnaire,
          ).generateConditions(response, patient!, {
            id: props.practitionerId,
            resourceType: 'Practitioner',
          });
          await updateConditionsByPatientId(conditions, patient!.id!);

          let mCarePlan = await processCristal(
            carePlan,
            response,
            questionnaire,
            patient,
            practitioner,
          );
          if (mCarePlan || carePlan)
            mCarePlan = await completeCarePlanActivity(
              mCarePlan || carePlan,
              questionnaire.id!,
              response.id!,
            );
          await setCarePlan(mCarePlan || carePlan);
        }
      }}
    />
  );
};
const Wrap = (props: CristalQuestionnaireProps) => {
  const { patient } = usePatient();

  return (
    <CristalProvider patientId={patient ? patient.id : undefined}>
      <CristalQuestionnaire {...props} />
    </CristalProvider>
  );
};
export default Wrap;
